module.exports = __webpack_public_path__ + "assets/img/8c2e940cf8103593ccc9a619fec07f04.png";